import { render, staticRenderFns } from "./OrgSettingsApps.vue?vue&type=template&id=0f38a02f&scoped=true&"
import script from "./OrgSettingsApps.vue?vue&type=script&lang=js&"
export * from "./OrgSettingsApps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f38a02f",
  null
  
)

export default component.exports